export const globalActions = {
  COLLAPSE_MENU: "COLLAPSE_MENU",
  COLLAPSE_TOGGLE: "COLLAPSE_TOGGLE",
  FULL_SCREEN: "FULL_SCREEN",
  FULL_SCREEN_EXIT: "FULL_SCREEN_EXIT",
  CHANGE_LAYOUT: "CHANGE_LAYOUT",
  LAYOUT_TYPE: "LAYOUT_TYPE",
  RESET: "RESET",
  NAV_BACK_COLOR: "NAV_BACK_COLOR",
  NAV_BACK_IMAGE: "NAV_BACK_IMAGE",
  NAV_BRAND_COLOR: "NAV_BRAND_COLOR",
  HEADER_BACK_COLOR: "HEADER_BACK_COLOR",
  NAV_ICON_COLOR: "NAV_ICON_COLOR",
  LAYOUT6_BACKGROUND: "LAYOUT6_BACKGROUND",
  RTL_LAYOUT: "RTL_LAYOUT",
  NAV_FIXED_LAYOUT: "NAV_FIXED_LAYOUT",
  HEADER_FIXED_LAYOUT: "HEADER_FIXED_LAYOUT",
  BOX_LAYOUT: "BOX_LAYOUT",
  NAV_DROPDOWN_ICON: "NAV_DROPDOWN_ICON",
  NAV_LIST_ICON: "NAV_LIST_ICON",
  NAV_ACTIVE_LIST_COLOR: "NAV_ACTIVE_LIST_COLOR",
  NAV_LIST_TITLE_COLOR: "NAV_LIST_TITLE_COLOR",
  NAV_LIST_TITLE_HIDE: "NAV_LIST_TITLE_HIDE",
  NAV_CONTENT_LEAVE: "NAV_CONTENT_LEAVE",
  NAV_COLLAPSE_LEAVE: "NAV_COLLAPSE_LEAVE",
  CONFIG_BLOCK: "CONFIG_BLOCK",
  CHANGE_PRE_LAYOUT: "CHANGE_PRE_LAYOUT",
  SHOW_PAGE_LOADER: "SHOW_PAGE_LOADER",
  HIDE_PAGE_LOADER: "HIDE_PAGE_LOADER"
};
